import { dataTrash } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrash = /*#__PURE__*/createIcon(dataTrash)
export default IconTrash
